var __default__ = {card:'m_26775b0a'};
export default __default__;